<template>
  <Card>
    <template #title
      ><div class="text-base font-medium -mt-2">{{ title }}</div></template
    >
    <template #content
      ><div class="relative">
        <Skeleton
          v-if="loader > 0"
          class="absolute top-0 left-0 w-full h-full"
        ></Skeleton>
        <div
          class="text-2xl line-height-1 -mt-3"
          :class="loader > 0 && 'opacity-0'"
        >
          {{ contentStr }}
        </div>
        <div
          v-if="cardType === 'normal' || cardType === 'minimal'"
          class="-mb-5 mt-2 text-bluegray-500"
          :class="(loader > 0 || cardType === 'minimal') && 'opacity-0'"
        >
          <span class="text-xs">{{
            cardType === "minimal" ? "Stats" : subContentStr
          }}</span>
        </div>
        <div
          v-if="cardType === 'diff'"
          class="-mb-5 mt-2 flex align-items-center gap-1 font-medium text-sm"
          :class="`${loader > 0 && 'opacity-0'} ${
            isPlus ? 'text-teal-400' : 'text-red-400'
          }`"
        >
          <i :class="`pi ${isPlus ? 'pi-angle-up' : 'pi-angle-down'}`"></i>
          <span>{{ subContentStr }}</span>
        </div>
      </div>
    </template>
  </Card>
</template>

<script setup>
import Card from "primevue/card";
import Skeleton from "primevue/skeleton";

const props = defineProps({
  title: {
    type: String,
  },
  contentStr: {
    type: String,
  },
  cardType: {
    type: String,
  },
  subContentStr: {
    type: String,
  },
  loader: {
    type: Number,
  },
  isPlus: {
    type: Boolean,
    default: true,
  },
});
</script>
